import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { toAppDisplayVersion, useShellContext } from '@apexx/shell-contract';
import { computed, onMounted, ref } from 'vue';

export function useAppVersion() {
	const shellContext = useShellContext();
	const rawVersion = ref<string | undefined>();
	const displayVersion = computed(() =>
		rawVersion.value ? toAppDisplayVersion(rawVersion.value) : undefined,
	);

	onMounted(async () => {
		let version = shellContext?.appVersion;

		if (!version && Capacitor.isNativePlatform()) {
			try {
				const info = await App.getInfo();
				version = info.version;
			} catch {
				// Ignore version lookup failures on unsupported platforms.
			}
		}

		rawVersion.value = version;
	});

	return {
		rawVersion,
		displayVersion,
	};
}
